// imove-branch: 队列中是否有上报任务

export default async function(ctx) {
  const cacheDataReportTask = ctx.payload?.cacheDataReportTask || [];
  if (cacheDataReportTask?.length) {
    return true;
  }
  return false;
}